export default class Coral {
	static init() {
		document.addEventListener('bless', () => {

			const $gform = document.querySelector('#gform_3');

			if(!$gform) {
				return;
			}

			new Coral();
		});
	}

	constructor() {
		jQuery(document).on('gform_page_loaded', (event, form_id, current_page) => {
			this.appendMarkup();
		});

		//TODO cleaner to get formID dynamically?
		const formId = '3';

		this.fields = [
			// 1.1
			{
				target: `#input_${formId}_32`,
				result: `#field_${formId}_51`,
				type: 'checkbox',
				markup: '',
			},
			{
				target: `#field_${formId}_8`,
				result: `#field_${formId}_51`,
				type: 'text',
				markup: '',
			},
			{
				target: `#field_${formId}_10`,
				result: `#field_${formId}_51`,
				type: 'text',
				markup: '',
			},

			// 1.2
			{
				target: `#input_${formId}_3`,
				result: `#field_${formId}_52`,
				type: 'checkbox',
				markup: '',
			},
			{
				target: `#field_${formId}_9`,
				result: `#field_${formId}_52`,
				type: 'text',
				markup: '',
			},
			{
				target: `#field_${formId}_11`,
				result: `#field_${formId}_52`,
				type: 'text',
				markup: '',
			},

			// 1.3
			{
				target: `#input_${formId}_12`,
				result: `#field_${formId}_53`,
				type: 'checkbox',
				markup: '',
			},
			{
				target: `#field_${formId}_13`,
				result: `#field_${formId}_53`,
				type: 'text',
				markup: '',
			},
			{
				target: `#field_${formId}_14`,
				result: `#field_${formId}_53`,
				type: 'text',
				markup: '',
			},

			// 1.4
			{
				target: `#input_${formId}_16`,
				result: `#field_${formId}_54`,
				type: 'checkbox',
				markup: '',
			},
			{
				target: `#field_${formId}_17`,
				result: `#field_${formId}_54`,
				type: 'text',
				markup: '',
			},
			{
				target: `#field_${formId}_18`,
				result: `#field_${formId}_54`,
				type: 'text',
				markup: '',
			},

			// 2.1
			{
				target: `#input_${formId}_49`,
				result: `#field_${formId}_55`,
				type: 'checkbox',
				markup: '',
			},

			// 2.2
			{
				target: `#input_${formId}_50`,
				result: `#field_${formId}_56`,
				type: 'checkbox',
				markup: '',
			},
		];

		this.createEventListeners();
	}

	createEventListeners() {
		this.fields.forEach((field) => {
			switch (field.type) {
				case 'checkbox':
					this.createCheckboxesMarkup(field);
					break;

				default:
					this.createTextMarkup(field);
					break;
			}
		});
	}

	appendMarkup() {
		this.fields.forEach((field) => {
			const result = document.querySelector(field.result);
			let resultDiv = result.querySelector('.tool-answer');

			// If there isn't a tool-answer div
			if (!resultDiv) {
				resultDiv = document.createElement('div');
				resultDiv.classList.add('tool-answer');
				resultDiv.innerHTML = field.markup;
				result.append(resultDiv);
			} else {
				const tempWrapper = document.createElement('div');
				tempWrapper.innerHTML = field.markup;
				resultDiv.append(tempWrapper.firstChild);
			}
		});
	}

	// Checkboxes en radios

	createCheckboxesMarkup(field) {
		jQuery('body').on('change', field.target, (e) => {
			const checked = document.querySelector(field.target).querySelectorAll(':checked');

			if (!checked.length) {
				field.markup = '';
				return;
			}

			const markup = `
				<ul>
					${Array.from(checked)
						.map((item) => `<li>${item.value}</li>`)
						.join('')}
				</ul>
			`;

			field.markup = markup;
		});
	}

	// Text en text-area

	createTextMarkup(field) {
		jQuery('body').on('change', field.target, (e) => {
			const textField = e.target;

			if (!textField.value) {
				field.markup = '';
				return;
			}

			field.markup = `<p>${textField.value}</p>`;
		});
	}
}
